import { Card, CardBody, CardHeader, CardTitle, StackLayout } from "@progress/kendo-react-layout";

const quickPrompts = ["Optimize margins", "Compare brands", "Forecast revenue", "Maximise velocity", "Maximise revenue"];

const insightCards = [
    {
        title: "Key Driver",
        text: "Promotion depth 15–20% maximises demand with balanced margin preservation."
    },
    {
        title: "Optimization",
        text: "Retail media ROI doubles during promotions when media timing is synchronized."
    },
    {
        title: "Recommendation",
        text: "Private label stabilises category margin profiles across market conditions."
    }
] as const;

const metrics = [
    { label: "Revenue", value: "$1.8M", delta: "+12.3%" },
    { label: "Profit", value: "$520K", delta: "+8.7%" },
    { label: "Retail Media ROI", value: "4.2x", delta: "+15.2%" },
    { label: "Confidence", value: "87%", delta: "High" }
] as const;

const opportunities = ["SKU-002 Promotion", "Bundle Uplift", "Media Mix Shift"] as const;

const Intelligence: React.FC = () => {
    return (
        <div className="container-fluid">
            <div className="row g-3 align-items-start">
                <div className="col-12 col-xxl-2 col-xl-3">
                    <Card>
                        <CardHeader>
                            <CardTitle>AI Command</CardTitle>
                        </CardHeader>
                        <CardBody>
                            <StackLayout orientation="vertical" gap={12}>
                                <div className="border rounded p-3 bg-light">
                                    Ask Sovra AI anything, e.g. “Optimize SKU-001 pricing for Q2”.
                                </div>
                                <StackLayout orientation="vertical" gap={8}>
                                    {quickPrompts.map(prompt => (
                                        <button key={prompt} type="button" className="btn btn-outline-secondary rounded-pill text-start">
                                            {prompt}
                                        </button>
                                    ))}
                                </StackLayout>
                            </StackLayout>
                        </CardBody>
                    </Card>
                </div>

                <div className="col-12 col-xxl-7 col-xl-6">
                    <StackLayout orientation="vertical" gap={16}>
                        <div className="row g-3">
                            {metrics.map(metric => (
                                <div className="col-12 col-md-6 col-xxl-3" key={metric.label}>
                                    <Card>
                                        <CardBody>
                                            <div className="small text-muted mb-1">{metric.label}</div>
                                            <div className="h2 mb-1">{metric.value}</div>
                                            <div className="fw-semibold text-success">{metric.delta}</div>
                                        </CardBody>
                                    </Card>
                                </div>
                            ))}
                        </div>

                        {/* <CommercialInvestmentMap /> */}

                        <Card>
                            <CardHeader>
                                <CardTitle>Sovra Recommendation</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <StackLayout orientation="vertical" gap={12}>
                                    <p className="fs-5 mb-0">Run a 20% promotion on SKU-002 with $12K retail media support.</p>
                                    <div className="row g-3">
                                        <div className="col-12 col-md-4">
                                            <div className="small text-muted">Revenue Impact</div>
                                            <div className="h3 text-success mb-0">+$420K</div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <div className="small text-muted">Profit Impact</div>
                                            <div className="h3 text-success mb-0">+$110K</div>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <div className="small text-muted">Projected ROI</div>
                                            <div className="h3 text-success mb-0">4.6x</div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2">
                                        <button type="button" className="btn btn-primary">
                                            Apply to Plan
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary">
                                            Simulate
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary">
                                            Export Strategy
                                        </button>
                                    </div>
                                </StackLayout>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardHeader>
                                <CardTitle>Top Commercial Opportunities</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <div className="row g-3">
                                    {opportunities.map((item, index) => (
                                        <div className="col-12 col-md-4" key={item}>
                                            <div className="border rounded p-3 h-100">
                                                <div className="small text-muted">
                                                    #
                                                    {index + 1}
                                                </div>
                                                <div className="fw-semibold">{item}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </StackLayout>
                </div>

                <div className="col-12 col-xxl-3 col-xl-3">
                    <Card>
                        <CardHeader>
                            <CardTitle>AI Insights</CardTitle>
                        </CardHeader>
                        <CardBody>
                            <StackLayout orientation="vertical" gap={10}>
                                {insightCards.map(insight => (
                                    <div key={insight.title} className="border rounded p-3 bg-light">
                                        <div className="fw-semibold mb-1">{insight.title}</div>
                                        <div>{insight.text}</div>
                                    </div>
                                ))}
                            </StackLayout>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Intelligence;
